import { decode } from '@web/utilities/entities';

// EX: &lt;script/&gt; --> script/
// EX: <script/> --> script/

const sanitizeValue = value => decode(value).replace(/[()<>]/g, '').replace(/\s\s+/g, ' ');

export { sanitizeValue };
